import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useOtherCarAssignmentApi } from "../../http/otherCarAssignment/api";
import { OtherCarAssignment } from "../../http/otherCarAssignment/types";
import { formatDate } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";
import VersionDialog from "../ui/VersionDialog";

type OtherCarAssignmentHistoryDialogProps = {
  itemToShowVersions: OtherCarAssignment;
  onClose: () => void;
};

const OtherCarAssignmentHistoryDialog: FC<OtherCarAssignmentHistoryDialogProps> = ({ itemToShowVersions, onClose }) => {
  const i18n = useI18n();
  const otherCarAssignmentApi = useOtherCarAssignmentApi();

  return (
    <HistoryDialog
      title={i18n.t.carPlates.versions}
      lastVersion={itemToShowVersions.versionNumber}
      entityId={itemToShowVersions.id}
      getEntityVersionHook={otherCarAssignmentApi.getOtherCarAssignmentVersion}
      getHistory={otherCarAssignmentApi.getOtherCarAssignmentHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {dataVersion.current?.type != dataVersion.next.type && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.type}
                  value={dataVersion.current?.type}
                  edited={dataVersion.next?.type}
                />
              </tr>
            )}
            {dataVersion.current?.costCenter != dataVersion.next.costCenter && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.costCenter}
                  value={dataVersion.current?.costCenter}
                  edited={dataVersion.next?.costCenter}
                />
              </tr>
            )}
            {dataVersion.current?.startDate != dataVersion.next.startDate && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.startDate}
                  value={dataVersion.current && formatDate(dataVersion.current?.startDate, i18n.language)}
                  edited={formatDate(dataVersion.next?.startDate, i18n.language)}
                />
              </tr>
            )}
            {(!dataVersion.current || dataVersion?.current?.endDate !== dataVersion.next.endDate) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.endDate}
                  value={dataVersion.current && formatDate(dataVersion.current?.endDate!, i18n.language)}
                  edited={formatDate(dataVersion.next?.endDate!, i18n.language)}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default OtherCarAssignmentHistoryDialog;
